import Home from '../views/Home'
import Ping from '../views/Ping'
import ProductInfo from '../views/ProductInfo'
import Error from '../views/Errors';
import Categories from "../views/Categories";
import CategoryDetail from "../views/CategoryDetail";
import CartSummary from '../views/CartSummary';
import Inactive from "../views/Inactive";
import SearchProducts from '../views/SearchProducts';
import PurchaseDetail from '../views/PurchaseDetail';
import Tracking from '../views/Tracking';

const routes: any = [
    {
        path: '/',
        exact: true,
        component: Home
    },
    {
        path: '/ping',
        exact: false,
        component: Ping
    },
    {    
        path: '/vende/:idCatalog',
        exact: true,
        component: Home
    },
    {
        path: '/vende/:idCatalog/error',
        exact: true,
        component: Error
    },
    {
        path: `/vende/:idCatalog/product-info/:idCategory/:idProduct`,
        // exact: false,
        component: ProductInfo
    },
    {
        path: `/vende/:idCatalog/product-info/:idCategory/:idProduct/:position`,
        // exact: false,
        component: ProductInfo
    },
    {
        path: `/vende/:idCatalog/categories`,
        exact: false,
        component: Categories
    },
    {
        path: `/vende/:idCatalog/detailCategory/:idCategory`,
        exact: false,
        component: CategoryDetail
    },
    {
        path: `/vende/:idCatalog/carrito/:idCart`,
        exact: false,
        component: CartSummary
    },
    {
        path: `/inactive`,
        exact: true,
        component: Inactive
    },
    {
        path: `/vende/:idCatalog/search`,
        exact: false,
        component: SearchProducts
    },
    {
        path: `/vende/:idCatalog/purchase/:idCart`,
        exact: true,
        component: PurchaseDetail
    },
    {
        path: `/vende/:idCatalog/guide/:idCart`,
        exact: true,
        component: Tracking
    },
    {
        path: `/vende/purchase/print/:purchase`,
        exact: true,
        component: PurchaseDetail
    },
    {
        route: '*',
        component: Error,
        routes: [
        // {
        //     path: '/about',
        //     exact: true,
        //     component: lazy(() => import('./views/about'))
        // },
        // {
        //     path: '/catalogo/:idCatalogo/carrito/:idCarrito',
        //     component: Home
        // },
        ]
    }
]

export default routes
